/**
 * Hand-maintained product overrides, keyed by SKU, merged onto product data
 * at load time (see `withRouteKeys` in `./index.js`).
 *
 * `src/store/product/collections/*.js` is regenerated wholesale by
 * `scripts/sync_products_from_xlsx_r2.py` from the product spreadsheet, so
 * fields added directly there are lost on the next sync. This file is never
 * touched by that script, so overrides here survive re-syncing.
 */
export const madeToOrderOverrides = {
  'SSX4-AH36': {
    availabilityStatus: 'Made to Order',
    estimatedLeadTime: '8–12 Weeks',
    availabilityDescription: 'Crafted specifically for your project.',
    availabilityLink: '/products/custom',
    hideStandardCtas: true,
  },
  KRJ07: {
    availabilityStatus: 'Made to Order',
    estimatedLeadTime: '8–12 Weeks',
    availabilityDescription: 'Crafted specifically for your project.',
    availabilityLink: '/products/custom',
    hideStandardCtas: true,
  },
  'SSX4-AH35': {
    availabilityStatus: 'Made to Order',
    estimatedLeadTime: '8–12 Weeks',
    availabilityDescription: 'Crafted specifically for your project.',
    availabilityLink: '/products/custom',
    hideStandardCtas: true,
  },
};
